"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardSDK = void 0;
class RewardSDK {
    /**
     * @param aptosRootAddress 0x-prefixed address
     */
    constructor(rewardProgramAddress) {
        this.rewardProgramAddress = rewardProgramAddress;
    }
    claimAndLendCollateralProgramRewardsIx({ collateralCoinType, rewardCoinType, redeemTicket, claimNoteAmount, lendTicket }) {
        return {
            type: "entry_function_payload",
            function: `${this.rewardProgramAddress}::reward_program_public::claim_and_lend_collateral_program_rewards`,
            type_arguments: [collateralCoinType, rewardCoinType],
            arguments: [redeemTicket, claimNoteAmount, lendTicket],
        };
    }
    resumeCollateralProgramIx({ lendTicket, endTime, rewardAmount, collateralCoinType, rewardCoinType }) {
        return {
            type: "entry_function_payload",
            function: `${this.rewardProgramAddress}::reward_program_admin::resume_collateral_reward_program`,
            type_arguments: [collateralCoinType, rewardCoinType],
            arguments: [lendTicket, endTime, rewardAmount],
        };
    }
    async getCollateralRewardVaultAddress({ aptosClient, collateralCoinType, rewardCoinType, }) {
        const [vaultAddress] = (await aptosClient.view({
            payload: {
                function: `${this.rewardProgramAddress}::reward_program_public::get_collateral_reward_vault_address`,
                typeArguments: [collateralCoinType, rewardCoinType],
                functionArguments: [],
            }
        }));
        return vaultAddress;
    }
    async getCollateralVestedRewards({ aptosClient, collateralCoinType, rewardCoinType, }) {
        const [vestedRewards] = (await aptosClient.view({
            payload: {
                function: `${this.rewardProgramAddress}::reward_program_public::get_collateral_vested_rewards`,
                typeArguments: [collateralCoinType, rewardCoinType],
                functionArguments: [],
            }
        }));
        return BigInt(vestedRewards);
    }
    async getLiabilityVestedRewards({ aptosClient, liabilityCoinType, rewardCoinType, }) {
        const [vestedRewards] = (await aptosClient.view({
            payload: {
                function: `${this.rewardProgramAddress}::reward_program_public::get_liability_vested_rewards`,
                typeArguments: [liabilityCoinType, rewardCoinType],
                functionArguments: [],
            }
        }));
        return BigInt(vestedRewards);
    }
    async getCollateralEarnedRewards({ aptosClient, portfolioAddress, collateralCoinType, rewardCoinType, }) {
        const [earnedRewards] = (await aptosClient.view({
            payload: {
                function: `${this.rewardProgramAddress}::reward_program_public::get_collateral_earned_rewards`,
                typeArguments: [collateralCoinType, rewardCoinType],
                functionArguments: [portfolioAddress],
            }
        }));
        return BigInt(earnedRewards);
    }
    async getLiabilityEarnedRewards({ aptosClient, portfolioAddress, liabilityCoinType, rewardCoinType, }) {
        const [earnedRewards] = (await aptosClient.view({
            payload: {
                function: `${this.rewardProgramAddress}::reward_program_public::get_liability_earned_rewards`,
                typeArguments: [liabilityCoinType, rewardCoinType],
                functionArguments: [portfolioAddress],
            }
        }));
        return BigInt(earnedRewards);
    }
}
exports.RewardSDK = RewardSDK;
